"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-empty-function */
const app_1 = require("app");
const React = require("react");
const Button_1 = require("../Button");
const FilterAutocomplete_1 = require("../FilterAutocomplete/FilterAutocomplete");
const FilterTextFormField_1 = require("../FilterTextFormField/FilterTextFormField");
const Forms_1 = require("../Forms");
const CountriesWithStates_1 = require("./CountriesWithStates");
const FilterItems_1 = require("./FilterItems");
const FilterTypings_1 = require("./FilterTypings");
const MosaicIcon_1 = require("../../../Shared/Components/MosaicIcon");
class MobileFilter extends React.Component {
    constructor(props) {
        super(props);
        this.previousSelectedFilters = this.props.selectedFilters;
        this.isChanged = false;
        this.isApplied = false;
        this.isCanceled = false;
        this.singleSelectionFilter = false;
        this.handleGroupListItemClick = (groupOpenValue, subGroup = false) => {
            this.singleSelectionFilter = this.isSingleSelectionFilter(groupOpenValue);
            this.setState({
                groupOpenValue,
                subGroup,
            }, () => {
                this.props.onFilterGroupChange(groupOpenValue);
            });
        };
        this.handleBackToGroupListClick = () => {
            const groupOpenValue = '';
            this.singleSelectionFilter = false;
            this.setState({
                groupOpenValue,
                subGroup: false,
            }, () => {
                this.props.onFilterGroupChange(groupOpenValue);
            });
            if (this.state.groupOpenValue === '') {
                this.props.close();
            }
        };
        this.renderHeader = () => {
            var _a;
            const { filters, dictionary, additionalData } = this.props;
            const { groupOpenValue, subGroup } = this.state;
            let title = '';
            if (groupOpenValue === '') {
                title = dictionary.filterHeaderDefaultLabel;
            }
            else if (subGroup) {
                title = additionalData.approvalType;
            }
            else {
                title = (_a = filters[groupOpenValue]) === null || _a === void 0 ? void 0 : _a.title;
            }
            return ((0, jsx_runtime_1.jsxs)("div", { className: "mobile-filter__header relative bg-surface-primary pt-md border-primary z-navigation px-sm w-full flex justify-between items-center border-b min-h-[75px]", children: [(0, jsx_runtime_1.jsxs)(Button_1.default, { className: "w-fit", onClick: this.handleBackToGroupListClick, children: [(0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "arrow-back-outline", className: "p-xs" }), (0, jsx_runtime_1.jsx)("div", { className: "pl-2xs subtitle-lg-moderate", children: title })] }), this.props.selectedFiltersCount > 0 && ((0, jsx_runtime_1.jsx)(Button_1.default, { className: "subtitle-md-moderate px-4 py-2", onClick: this.handleFilterReset, children: dictionary.resetBtnLabel }))] }));
        };
        this.renderSelectedItems = (groupValue, subGroup = false) => {
            const { filters, selectedFilters } = this.props;
            if (selectedFilters[groupValue] && selectedFilters[groupValue].length > 0) {
                return ((0, jsx_runtime_1.jsx)("ul", { className: "body-sm text-secondary", children: filters[groupValue].items
                        .filter(item => selectedFilters[groupValue].indexOf(item.value) > -1)
                        .filter(item => subGroup ? item.title.indexOf('@') > -1 : item.title.indexOf('@') === -1)
                        .map(item => ((0, jsx_runtime_1.jsx)("li", { children: subGroup ? item.title.split('@')[1] : item.title }, item.value))) }));
            }
            return null;
        };
        this.getSubGroups = filter => {
            const subGroups = {};
            if (filter.items.length > 0) {
                filter.items.forEach((item, itemIndex) => {
                    const subFilters = item.title.split('@');
                    if (subFilters.length > 1) {
                        if (!subGroups[subFilters[0]]) {
                            subGroups[subFilters[0]] = [];
                        }
                        subGroups[subFilters[0]].push(Object.assign(Object.assign({}, filter.items[itemIndex]), { title: subFilters[1] }));
                    }
                });
            }
            return subGroups;
        };
        this.getSubOptions = (subGroups, filter) => {
            const subGroupItems = [];
            Object.keys(subGroups).forEach(subGroup => {
                if (!filter.items
                    .map(item => ({
                    title: item.title,
                    selected: item.selected,
                }))
                    .filter(item => Object.keys(subGroups).indexOf(item.title) > -1 && item.selected)
                    .filter(item => item.title === subGroup)[0]) {
                    return;
                }
                const options = [];
                subGroups[subGroup].forEach(item => {
                    options.push(item);
                });
                subGroupItems.push({
                    title: subGroup,
                    options,
                });
            });
            return subGroupItems;
        };
        this.renderFilters = (groupValue) => {
            const { filters, hideGroupsWithOneItem, renderEmptyNavigationGroup } = this.props;
            let onClick = null;
            let renderedItems = null;
            const filter = filters[groupValue] || {};
            if (hideGroupsWithOneItem && (0, app_1.safe)(filters[groupValue].items).length <= 1) {
                return null;
            }
            const subGroups = this.getSubGroups(filter);
            switch (filter.guiType) {
                case FilterTypings_1.FilterGroupGuiTypeEnum.Autosuggest:
                    renderedItems = this.renderAutosuggestFilters(filter, groupValue);
                    break;
                case FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy:
                case FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown:
                    renderedItems = this.renderDropdownFilters(filter, groupValue);
                    break;
                case FilterTypings_1.FilterGroupGuiTypeEnum.Textbox:
                    renderedItems = this.renderTextboxFilters(filter, groupValue);
                    break;
                default:
                    if (!filter.items || !filter.items.length) {
                        return renderEmptyNavigationGroup
                            ? this.renderEmptyNavigationFilter(filter, groupValue)
                            : null;
                    }
                    renderedItems = this.renderNavigationGroup(filter, groupValue);
                    onClick = () => {
                        this.handleGroupListItemClick(groupValue);
                    };
            }
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("li", { className: "filters-group-list-item", onClick: onClick, "data-filter-id": filter.value, children: renderedItems }), Object.keys(subGroups).length > 0 &&
                        filter.items
                            .map(item => ({
                            label: item.title,
                            selected: item.selected,
                        }))
                            .filter(item => Object.keys(subGroups).indexOf(item.label) > -1 && item.selected)
                            .length > 0 && ((0, jsx_runtime_1.jsx)("li", { className: "filters-group-list-item", onClick: () => this.handleGroupListItemClick(groupValue, true), children: this.renderNavigationGroup(Object.assign(Object.assign({}, filter), { title: this.props.additionalData.approvalType, items: this.getSubOptions(subGroups, filter) }), groupValue, true) }))] }, filter.value));
        };
        this.renderNavigationGroup = (filter, groupValue, subGroup = false) => {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "filters-group cursor-pointer relative px-md py-sm active:bg-fill-primary-pressed hover:bg-fill-primary-hovered flex min-h-[48px] items-start justify-between rounded-2xl no-underline", children: [(0, jsx_runtime_1.jsxs)("div", { className: "filters-group__heading subtitle-lg-strong relative w-full", children: [filter.title, this.renderSelectedItems(groupValue, subGroup)] }), (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "chevron-right", className: "mt-0.5" })] }));
        };
        this.renderEmptyNavigationFilter = (filter, groupValue) => {
            return ((0, jsx_runtime_1.jsx)("li", { className: "filters-group-list-item filters-group-list-item--disabled", children: this.renderNavigationGroup(filter, groupValue) }, filter.value));
        };
        this.renderDropdownFilters = (filter, groupValue) => {
            const { selectedFilters, dictionary } = this.props;
            const defaultLabel = dictionary.countryDefaultLabel || filter.title;
            const handleChange = (e) => {
                this.handleFilterChange(groupValue, e.target.value);
            };
            return ((0, jsx_runtime_1.jsx)(Forms_1.FormDropdown, { name: defaultLabel, value: selectedFilters[groupValue] && selectedFilters[groupValue][0], label: filter.label, placeholder: filter.placeholder || defaultLabel, options: filter.items, onChange: handleChange, hiddenDefaultOption: !defaultLabel, cssClass: "px-md py-sm [&_label]:subtitle-lg-strong" }));
        };
        this.renderTextboxFilters = (filter, groupValue) => {
            const { selectedFilters } = this.props;
            let handleChange;
            if (filter.typeAlias === FilterTypings_1.FilterGroupTypeAlias.ZipCode) {
                const selectedCountry = this.getSelectedFilterByType(selectedFilters, FilterTypings_1.FilterGroupTypeAlias.Countries);
                if (!selectedCountry) {
                    return null;
                }
                handleChange = changedValue => {
                    if (changedValue) {
                        value = `${FilterTypings_1.FilterGroupTypeAlias.ZipCode}:${changedValue}`;
                    }
                    return this.handleFilterChange(groupValue, value);
                };
            }
            else {
                handleChange = changedValue => {
                    return this.handleFilterChange(groupValue, changedValue);
                };
            }
            const defaultLabel = filter.title;
            let value = (selectedFilters[groupValue] && selectedFilters[groupValue][0]) || '';
            const inputValue = value.split(':');
            if (inputValue && inputValue.length > 1) {
                value = inputValue[1];
            }
            return ((0, jsx_runtime_1.jsx)(FilterTextFormField_1.FilterTextField, { value: value, placeholder: defaultLabel, onChange: handleChange, maxLength: 25 }));
        };
        this.renderAutosuggestFilters = (filter, groupValue) => {
            const { selectedFilters, dictionary, additionalData } = this.props;
            const handleChange = (key) => {
                this.handleFilterChange(groupValue, key);
            };
            let selectedCountry;
            let defaultLabel = filter.title;
            switch (filter.typeAlias) {
                case FilterTypings_1.FilterGroupTypeAlias.Countries:
                    defaultLabel = dictionary.countryDefaultLabel || defaultLabel;
                    return ((0, jsx_runtime_1.jsx)(FilterAutocomplete_1.FilterAutocomplete, { placeholder: defaultLabel, onChange: handleChange, items: additionalData.countryOptions, selectedOption: (selectedFilters[groupValue] && selectedFilters[groupValue][0]) || '' }));
                case FilterTypings_1.FilterGroupTypeAlias.Region:
                    this.isNoData(additionalData.stateOptions, additionalData.stateOptions.states.length);
                    selectedCountry = this.getSelectedFilterByType(selectedFilters, FilterTypings_1.FilterGroupTypeAlias.Countries);
                    this.isNoData(selectedCountry, CountriesWithStates_1.mappedCountriesWithStates.some(country => country === selectedCountry));
                    return ((0, jsx_runtime_1.jsx)(FilterAutocomplete_1.FilterAutocomplete, { placeholder: defaultLabel, onChange: handleChange, items: additionalData.stateOptions.states, selectedOption: (selectedFilters[groupValue] && selectedFilters[groupValue][0]) || '' }));
                case FilterTypings_1.FilterGroupTypeAlias.City:
                    this.isNoData(additionalData.citiesOptions, additionalData.citiesOptions.cities.length);
                    selectedCountry = this.getSelectedFilterByType(selectedFilters, FilterTypings_1.FilterGroupTypeAlias.Countries);
                    const selectedRegion = this.getSelectedFilterByType(selectedFilters, FilterTypings_1.FilterGroupTypeAlias.Region);
                    if (!selectedCountry ||
                        (CountriesWithStates_1.mappedCountriesWithStates.some(country => country === selectedCountry) &&
                            !selectedRegion)) {
                        return null;
                    }
                    return ((0, jsx_runtime_1.jsx)(FilterAutocomplete_1.FilterAutocomplete, { placeholder: defaultLabel, onChange: handleChange, items: additionalData.citiesOptions.cities, selectedOption: (selectedFilters[groupValue] && selectedFilters[groupValue][0]) || '' }));
            }
            // eslint:disable-next-line:no-console
            console.warn(`There is no such autosuggest: ${filter.typeAlias} \\ ${filter.title}`);
        };
        this.renderBody = () => {
            const { groupOpenValue } = this.state;
            return ((0, jsx_runtime_1.jsx)("div", { className: "mobile-filter__body relative px-sm pt-sm pb-md min-h-0 flex-1 overflow-y-auto overscroll-contain", children: groupOpenValue !== '' ? this.renderGroup() : this.renderGroupList() }));
        };
        this.renderFooter = () => {
            const { close, dictionary } = this.props;
            const { groupOpenValue } = this.state;
            if (groupOpenValue !== '') {
                return ((0, jsx_runtime_1.jsx)("div", { className: "mobile-filter__footer pt-sm mx-sm pb-3xl border-primary gap-xs flex flex-none flex-col border-t", children: (0, jsx_runtime_1.jsx)(Button_1.default, { className: "btn-primary w-full", onClick: this.handleBackToGroupListClick, children: dictionary.doneBtnLabel }) }));
            }
            if (this.isChanged) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "mobile-filter__footer pt-sm mx-sm pb-3xl border-primary gap-xs flex flex-none flex-col border-t", children: [(0, jsx_runtime_1.jsx)(Button_1.default, { className: "btn-secondary w-full", onClick: this.handleCancel, children: dictionary.cancelBtnLabel }), (0, jsx_runtime_1.jsx)(Button_1.default, { className: "btn-primary w-full", onClick: this.handleApply, children: dictionary.applyBtnLabel })] }));
            }
            return ((0, jsx_runtime_1.jsx)("div", { className: "mobile-filter__footer pt-sm mx-sm pb-3xl border-primary gap-xs flex flex-none flex-col border-t", children: (0, jsx_runtime_1.jsx)(Button_1.default, { label: dictionary.closeBtnLabel, className: "btn-primary w-full", onClick: close }) }));
        };
        this.handleFilterChange = (groupValue, filterValue) => {
            const { onFilterChange } = this.props;
            this.isChanged = true;
            onFilterChange(groupValue, filterValue);
            if (this.singleSelectionFilter) {
                // Auto-close single-selection filters
                setTimeout(() => {
                    this.handleBackToGroupListClick();
                });
            }
        };
        this.handleFilterReset = () => {
            const { onFilterReset } = this.props;
            this.isChanged = true;
            this.singleSelectionFilter = false;
            this.setState({ groupOpenValue: '' });
            onFilterReset();
        };
        this.handleApply = () => {
            const { close, onApply } = this.props;
            this.isApplied = true;
            onApply && onApply();
            close();
        };
        this.handleCancel = () => {
            const { onCancel, close } = this.props;
            this.isCanceled = true;
            if (this.isChanged) {
                onCancel(this.previousSelectedFilters);
            }
            close();
        };
        this.handleCloseWithoutApplying = () => {
            const { onCancel } = this.props;
            if (!this.isApplied && !this.isCanceled && this.isChanged) {
                onCancel(this.previousSelectedFilters);
            }
        };
        this.getSelectedFilterByType = (selectedFilters, typeAlias) => {
            const filterKey = (0, app_1.fromObjectToArray)(this.props.filters).filter(f => f.typeAlias === typeAlias)[0].value;
            const filterHasValue = selectedFilters[filterKey] && selectedFilters[filterKey].length;
            if (!filterHasValue) {
                return null; // do not render if country not selected
            }
            /*selectedCountry*/
            return selectedFilters[filterKey][0];
        };
        this.isSingleSelectionFilter = (groupOpenValue) => {
            const { filters } = this.props;
            const currentFilter = filters && filters[groupOpenValue];
            return currentFilter && currentFilter.guiType === FilterTypings_1.FilterGroupGuiTypeEnum.Radio;
        };
        this.state = { groupOpenValue: '', subGroup: false };
    }
    componentWillUnmount() {
        this.handleCloseWithoutApplying();
    }
    componentDidMount() {
        app_1.ComponentService.UpdateComponentsSelector();
    }
    render() {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "mobile-filter space-y-md flex h-full min-h-0 w-full flex-col", children: [this.props.renderSpinner ? this.props.renderSpinner() : null, this.renderHeader(), this.renderBody(), !this.singleSelectionFilter && this.renderFooter()] }));
    }
    renderGroupList() {
        const { filterGroupsOrder } = this.props;
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("ul", { className: "filters-group-list", children: (0, app_1.safe)(filterGroupsOrder).map(this.renderFilters) }) }, "group-list"));
    }
    isNoData(data, selectedData) {
        if (!data || !selectedData) {
            return null;
        }
    }
    renderGroup() {
        var _a, _b;
        const { filters, selectedFilters } = this.props;
        const { groupOpenValue, subGroup } = this.state;
        const items = [];
        if (subGroup) {
            this.getSubOptions(this.getSubGroups(filters[groupOpenValue]), filters[groupOpenValue]).forEach(item => {
                items.push(item);
            });
        }
        else {
            (_a = filters[groupOpenValue]) === null || _a === void 0 ? void 0 : _a.items.filter(item => item.title.indexOf('@') === -1).forEach(item => items.push(item));
        }
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { className: "filters-group relative flex items-center min-h-12 pb-3 pt-3", children: (0, jsx_runtime_1.jsx)(FilterItems_1.default, { guiType: (_b = filters[groupOpenValue]) === null || _b === void 0 ? void 0 : _b.guiType, groupValue: groupOpenValue, items: items, selectedFilters: selectedFilters, onClick: this.handleFilterChange }) }) }, "group"));
    }
}
MobileFilter.defaultProps = {
    close: () => undefined,
    hideGroupsWithOneItem: false,
    onCancel: () => undefined,
    onFilterChange: () => undefined,
    onFilterGroupChange: () => undefined,
    onFilterReset: () => undefined,
};
exports.default = MobileFilter;
